import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

import CurrencySelect from 'components/shared/CurrencySelect/CurrencySelect';

import { colours } from 'themes/default';

export const StyledCurrencySelect = styled(CurrencySelect)`
  margin: auto 0;
`;

export const HeadingWithError = styled.h2`
  ${ifProp(
    'error',
    css`
      color: ${colours.Messaging.ErrorRed};
    `
  )}
`;

export const ExtraTitle = styled.h2`
  color: ${colours.Shades.BlueShade40};
`;
